import { render, staticRenderFns } from "./toDoListDashboard.vue?vue&type=template&id=142692f8"
import script from "./toDoListDashboard.vue?vue&type=script&lang=js"
export * from "./toDoListDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports